/* Compact cart preview. All cart mutations remain owned by MayaCartController. */
import { refreshAffirmMessaging } from '@maya/cart-affirm';

class MayaCartPopup extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.dialog = this.querySelector('dialog');
    this.trigger = this.querySelector('[data-popup-open]');
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-popup-open]')) {
        event.preventDefault();
        if (this.dialog.open) this.close();
        else this.open();
      }
      if (event.target.closest('[data-popup-close]')) this.close();
      if (event.target.closest('[data-popup-view-cart]')) {
        event.preventDefault();
        const heading = document.querySelector('.mb-cart-title');
        this.close(heading);
      }
      if (event.target === this.dialog) {
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
      }
    }, options);
    this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.close(); }, options);
    this.dialog.addEventListener('close', () => {
      if (this.dialog.hasAttribute('data-affirm-suspended')) return;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.dialog.removeAttribute('data-closing');
      if (this.returnFocus?.matches('.mb-cart-title')) this.returnFocus.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
      (this.returnFocus?.isConnected ? this.returnFocus : this.trigger).focus({ preventScroll: true });
      this.returnFocus = null;
    }, options);
    window.addEventListener('resize', () => { if (this.dialog.open) this.position(); }, options);
  }
  disconnectedCallback() {
    clearTimeout(this.closeTimer);
    this.abort?.abort();
    this.dialog?.close();
  }
  position() {
    const header = this.closest('header-component') || this.closest('header');
    const bottom = header?.getBoundingClientRect().bottom || this.trigger.getBoundingClientRect().bottom;
    this.style.setProperty('--mb-popup-top', `${Math.max(12, bottom + 8)}px`);
  }
  open() {
    clearTimeout(this.closeTimer);
    this.dialog.removeAttribute('data-closing');
    this.position();
    this.dialog.showModal();
    this.trigger.setAttribute('aria-expanded', 'true');
    this.dialog.querySelector('h2')?.focus({ preventScroll: true });
    refreshAffirmMessaging();
  }
  close(returnFocus = this.trigger) {
    if (!this.dialog.open || this.dialog.hasAttribute('data-closing')) return;
    this.returnFocus = returnFocus;
    this.dialog.setAttribute('data-closing', '');
    const configured = parseFloat(getComputedStyle(this).getPropertyValue('--mb-popup-duration'));
    const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : Number.isFinite(configured) ? configured : 300;
    this.closeTimer = setTimeout(() => this.dialog.close(), duration);
  }
  render(replacement) {
    const content = replacement.querySelector('.mb-cart-popup-content');
    if (content) this.querySelector('.mb-cart-popup-content').replaceWith(content);
    if (this.dialog.open) refreshAffirmMessaging();
  }
}
if (!customElements.get('mb-cart-popup')) customElements.define('mb-cart-popup', MayaCartPopup);
